export const cilChevronDoubleLeft = ["24 24","<path d='M12.94 6.725l-3.725-3.725-8.84 8.834 3.198 3.198 0.532 0.528 5.111 5.111 3.725-3.725-5.11-5.11zM9.215 18.549l-6.716-6.716 1.603-1.603 0.002 0.002 5.11-5.11 1.604 1.604-5.11 5.11 5.11 5.11z'></path><path d='M23.309 6.725l-3.725-3.725-8.837 8.837 3.194 3.194 0.529 0.525 5.114 5.114 3.725-3.725-5.11-5.11zM21.188 16.946l-1.603 1.603-6.718-6.714 1.609-1.609 0.002 0.002 5.107-5.107 1.603 1.603-5.11 5.11z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-chevron-double-left.js
// module id = null
// module chunks = 